import styled from "styled-components";

export const Pricing = styled.div`
  width: 800px;
  max-width: 90%;
  margin: 0 auto;
  padding-bottom: calc(7rem + env(safe-area-inset-bottom, 0px));

  h1 {
    margin: 4rem 0;
    font-size: 2rem;
    line-height: 1.15;

    > span {
      display: inline-flex;
      align-items: center;
      min-width: 0;
    }
  }

  .input-range__slider {
    background: white;
    height: 1.5rem;
    width: 1.5rem;
    margin-top: -14px;
    border: none;
    transition: transform 0.1s ease-out, box-shadow 0.1s ease-out;
  }

  .input-range__track.input-range__track--background {
    background: linear-gradient(90deg, #176ac1 0%, #ad7ac6 52%, #f18d25 100%);
  }

  .input-range__track--active {
    background: transparent !important;
  }

  .input-range {
    width: calc(100% - 28px);
    margin: auto;
  }

  .input-range__label-container {
    color: white;
    font-size: 18px;
    font-family: "Inter", sans-serif;

    &::before {
      content: "\\20B9";
    }
  }

  .input-range__label.input-range__label--max,
  .input-range__label.input-range__label--min {
    top: 25px;
  }

  .input-range__label--value {
    top: -45px;
    left: 2px;
  }

  @media screen and (max-width: 768px) {
    max-width: calc(100% - 2rem);
    padding-bottom: calc(11rem + env(safe-area-inset-bottom, 0px));

    h1 {
      gap: clamp(0.85rem, 4vw, 1.25rem);
      margin: 1.75rem 0 3rem;
      font-size: clamp(2rem, 9vw, 2.4rem);
      line-height: 1.12;
      white-space: nowrap;

      svg {
        width: 1.75rem;
        height: 1.75rem;
        flex-shrink: 0;
      }
    }

    .input-range__label-container {
      font-size: 16px;
    }
  }
`;
